import { useInstitutionContext } from "@hooks/institutionContext";
import { getTimeZoneAbbreviation } from "@utils/time";
import Filters from "byzantine/src/filters";

export function TimezoneInfo() {
  const { institution } = useInstitutionContext();

  return (
    <div>
      {Filters.humanize(
        `${institution.time_zone} (${getTimeZoneAbbreviation(institution.time_zone)})`
      )}
    </div>
  );
}
